/**
 * Escape closes a dialog from anywhere while it's open, not only when focus is
 * inside it: Safari doesn't focus checkboxes on click, so focus can be
 * outside the dialog.
 */
import { useEffect } from "react";

export function useCloseOnEscape(onClose: () => void): void {
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => {
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [onClose]);
}
